export default __webpack_public_path__ + "static/screeny-130-gpz-i-2-1253bf908ae2e06d1aaa7700db21ce59.jpg";